'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ErrorMessages=require('../../../../../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

FlightOrPairingIdSearchDirective=function(_BaseControllerBacked){_inherits(FlightOrPairingIdSearchDirective,_BaseControllerBacked);function FlightOrPairingIdSearchDirective(){_classCallCheck(this,FlightOrPairingIdSearchDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FlightOrPairingIdSearchDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/flightOrPairingIdSearchDirective/flightOrPairingIdSearchTemplate'}},{key:'objectBindings',get:function()

{return['pairing']}},{key:'controller',get:function()

{return FlightOrPairingIdSearchController}}]);return FlightOrPairingIdSearchDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
query:null,
selectedPairing:null,
results:null};let


FlightOrPairingIdSearchController=(_class=function(_BaseController){_inherits(FlightOrPairingIdSearchController,_BaseController);
function FlightOrPairingIdSearchController($scope,$timeout,socketService,notificationService,dateService,uncaughtErrorHandler){_classCallCheck(this,FlightOrPairingIdSearchController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout,$scope));
_this2._$scope=$scope;
_this2._$timeout=$timeout;
_this2._socketService=socketService;
_this2._notificationService=notificationService;
_this2._dateService=dateService;

_.defaults(_this2,ControllerDefaults);

_this2._safeWatch('selectedPairing',function(){return _this2._updateSelectedPairingData()});
_this2._safeWatch('pairingDate',function(){return _this2._updateSelectedPairingData()});

_this2.getResultsForFlightOrPairingIdSearch=_this2._getResultsForFlightOrPairingIdSearch.bind(_this2);

_this2._$timeout(function(){
_this2._updateSelectedPairingData();
});return _this2;
}FlightOrPairingIdSearchController.prototype.

_updateSelectedPairingData=function _updateSelectedPairingData(){var _this3=this;
this._$timeout(function(){
if(_this3.flightOrPairingIdSelection&&_this3.pairingDate){
_this3._selectedPairingData={
id:_this3.pairingId,
date:_this3.pairingDate,
crewType:_this3.crewType,
flights:_this3.flights,
flightNumber:_this3.flightNumber};

}else{
_this3._selectedPairingData=null;
}
});
};FlightOrPairingIdSearchController.prototype.






























_getResultsForFlightOrPairingIdSearch=function(){var ref=_asyncToGenerator(function*(query){
const currentDateStringFromClient=this._dateService.now();
if(!_.exists(query)||query.length===0){
return[];
}

const socketResponse=yield this._socketService.sendAndWaitForResponse('FlightOrPairingIdSearch',{query:query,fromDate:currentDateStringFromClient});

if(!SocketResponse.succeeded(socketResponse)){
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
return[];
}

let airlineCode;
let upperCaseQuery=query.toUpperCase();
if(/^\w+[ ]+\d+$/.test(upperCaseQuery)){
const airlineCode=upperCaseQuery.split(' ')[0].trim();
upperCaseQuery=upperCaseQuery.slice(airlineCode.length).trim();
}
const containsQuery=function(str){return _.exists(str)&&str.indexOf(upperCaseQuery)!==-1};

const results=_(socketResponse.body.results).
groupBy('pairingId').
flatMap(function(group){
const{pairingId:pairingId,flights:flights}=group[0];

const model={
crewType:group.length!==1?'*':group[0].crewType,
pairingId:pairingId,
flights:flights};


const relevantResults=[];
const pairingIdContainsQuery=containsQuery(pairingId);
const pairingIdStartsWithQuery=pairingId.startsWith(upperCaseQuery);

if(pairingIdStartsWithQuery){
relevantResults.push(_createResultForPairingId(model));
}

for(const flight of flights){
if(!containsQuery(flight.flightNumber)){
if(pairingIdContainsQuery||
!containsQuery(flight.origin)&&!containsQuery(flight.destination)){
continue;
}
}

if(_.exists(airlineCode)&&flight.cxCd!==airlineCode){
continue;
}

relevantResults.push(_createResultForFlight(flight,model));
}

if(relevantResults.length===0&&pairingIdContainsQuery){
relevantResults.push(_createResultForPairingId(model));
}

return relevantResults;
}).
sortBy([
function(result){
let score=0;

if(result.value.pairingId===upperCaseQuery){
score++;
}

if(result.value.flights.some(function(f){return f.flightNumber===upperCaseQuery})){
score++;
}

if(airlineCode&&result.formattedResult.primaryLabel.startsWith(airlineCode)&&containsQuery(result.formattedResult.primaryLabel)){
score++;
}

if(result.formattedResult.primaryLabel.startsWith(upperCaseQuery)){
score+=0.5;
}

if(result.formattedResult.secondaryLabel.startsWith(upperCaseQuery)){
score+=0.5;
}
return-1*score;
},'value.pairingId','formattedResult.primaryLabel']).
value();

return results;
});function _getResultsForFlightOrPairingIdSearch(query){return ref.apply(this,arguments)}return _getResultsForFlightOrPairingIdSearch}();_createClass(FlightOrPairingIdSearchController,[{key:'pairingId',get:function(){return _.get(this,'selectedPairing.value.pairingId',null)}},{key:'crewType',get:function(){return this.crewTypeFromDateSelector||_.get(this,'selectedPairing.value.crewType',null)}},{key:'flights',get:function(){return _.get(this,'selectedPairing.value.flights',null)}},{key:'flightNumber',get:function(){return _.get(this,'selectedPairing.value.flightNumber',null)}},{key:'flightOrPairingIdSelection',get:function(){return _.get(this,'selectedPairing.value',null)}},{key:'pairing',get:function(){return this._selectedPairingData},set:function(newPairing){}}]);return FlightOrPairingIdSearchController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_getResultsForFlightOrPairingIdSearch',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_getResultsForFlightOrPairingIdSearch'),_class.prototype)),_class);


const _createResultForFlight=function(flight,model){return{
formattedResult:{
primaryLabel:`${flight.cxCd} ${flight.flightNumber}`,
secondaryLabel:`${model.pairingId}, ${flight.origin}-${flight.destination}`},

value:_.merge({flightNumber:flight.flightNumber},model)}};


const _createResultForPairingId=function(model){return{
formattedResult:{
primaryLabel:model.pairingId,
secondaryLabel:model.flights.filter(function(f){return _.exists(f.flightNumber)}).map(function(f){return`${f.origin}-${f.destination}`}).join(', ')},

value:model}};


module.exports=FlightOrPairingIdSearchDirective;
//# sourceMappingURL=flightOrPairingIdSearchDirective.js.map
